import { AxiosResponseHeaders } from 'axios';

export interface PaginationInfo {
  totalPages: number;
  pageSize: number;
  hasPrevious: boolean;
  hasNext: boolean;
  totalCount: number;
  currentPage: number;
}

export const getPaginationHeader = (
  headers: AxiosResponseHeaders | undefined,
): PaginationInfo | null => {
  if (!headers) return null;

  const paginationHeader = headers['x-pagination'];

  if (!paginationHeader) return null;

  try {
    const paginationInfo: PaginationInfo = JSON.parse(paginationHeader);
    return paginationInfo;
  } catch (error) {
    return null;
  }
};
